import { Link } from 'react-router-dom';

const values = [
  {
    icon: 'ri-check-double-line',
    title: '数据准确',
    description: '所有开奖数据均来源于官方渠道，确保数据真实准确性，建立多重数据校验机制。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '更新及时',
    description: '开奖后第一时间同步更新数据，分布式数据采集系统保障数据实时性。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '服务至上',
    description: '7×24小时客服在线，用心倾听用户声音，持续优化产品体验。',
  },
  {
    icon: 'ri-cpu-line',
    title: '技术创新',
    description: '持续投入技术研发，引入AI智能分析和大数据技术提供精准洞察。',
  },
];

export default function BrandSection() {
  return (
    <section className="py-10">
      <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 text-center">
        品牌介绍
      </h2>
      <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-3xl mx-auto text-center">
        彩客网成立于2015年，是国内领先的彩票数据查询与智能分析平台。我们致力于为广大彩民提供准确、及时、全面的彩票开奖数据、走势分析和智能预测服务。经过近十年的发展，彩客网已成为超过500万彩民信赖的首选平台。
      </p>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mt-10 max-w-3xl mx-auto">
        {values.map((val, idx) => (
          <div key={idx} className="text-center">
            <div className="w-12 h-12 mx-auto flex items-center justify-center bg-primary-100 rounded-xl">
              <i className={`${val.icon} text-primary-600 text-xl`}></i>
            </div>
            <h4 className="mt-3 text-sm font-semibold text-foreground-900">{val.title}</h4>
            <p className="mt-1 text-xs text-foreground-500 leading-relaxed">{val.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}